import { render } from "./FileTable.vue?vue&type=template&id=e32e72a0"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__